module.exports = __webpack_public_path__ + "static/media/stocking.484335bf.svg";